import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="min-one-aktiv-switch"
export default class extends Controller {
	static targets = ["fieldset"]

	connect() {
		if (this.fieldsetTargets.length > 1) {
			// Allen Switchbutton die Check-Action zuweisen
			this.fieldsetTargets.forEach((element) => {
				const switchButton = element.querySelector("button[role='switch']")

				switchButton.dataset.action = `${switchButton.dataset.action} min-one-aktiv-switch#check`
			})
		}
	}

	check(event) {
		if (this.alleCheckboxenDeaktiviert()) {
			// Es wird die Checkbox im ersten fieldset welches nicht gerade deaktiviert wurde auf aktiv gesetzt
			const fieldset = this.fieldsetTargets.find((el) => !el.contains(event.target))

			if (fieldset) {
				const switchButton = fieldset.querySelector("button[role='switch']")

				if (switchButton) switchButton.dispatchEvent(new Event("click"))
			}
		}
	}

	// Private Methods

	alleCheckboxenDeaktiviert() {
		return this.checkboxen().every((checkbox) => !checkbox.checked)
	}

	checkboxen() {
		const checkboxen = []

		this.fieldsetTargets.forEach((element) => {
			const checkbox = element.querySelector("input[type='checkbox'].sr-only")

			if (checkbox) checkboxen.push(checkbox)
		})

		return checkboxen
	}
}
